import { inlineAtomNode } from '#src/tiptap/nodes/shared.ts'

export const InsertMedicationsButtonNode = inlineAtomNode(
  'insert-medications-button',
  'button',
  { display: { isDisplay: true } }
)
